/**
 * Blob URL Lifecycle Manager
 *
 * Tracks outstanding blob URLs per conversation so they can be cleaned up
 * when the user switches conversations (before socket reconciliation).
 */

const pendingBlobUrls = new Map<string, Set<string>>();

export function trackBlobUrl(conversationId: string, url: string) {
  if (!url.startsWith('blob:')) return;
  let set = pendingBlobUrls.get(conversationId);
  if (!set) { set = new Set(); pendingBlobUrls.set(conversationId, set); }
  set.add(url);
}

export function untrackBlobUrl(url: string) {
  for (const set of pendingBlobUrls.values()) set.delete(url);
}

export function revokeBlobUrl(url: string) {
  if (!url.startsWith('blob:')) return;
  URL.revokeObjectURL(url);
  untrackBlobUrl(url);
}

export function revokeAttachmentBlobUrls(
  attachments: Array<{ url?: string; fileUrl?: string; previewUrl?: string }>
) {
  for (const a of attachments) {
    if (a.url) revokeBlobUrl(a.url);
    if (a.fileUrl) revokeBlobUrl(a.fileUrl);
    if (a.previewUrl) revokeBlobUrl(a.previewUrl);
  }
}

/** Revoke all blob URLs for a conversation. Call on conversation switch. */
export function revokeConversationBlobUrls(conversationId: string) {
  const set = pendingBlobUrls.get(conversationId);
  if (!set || set.size === 0) return;
  for (const url of set) {
    try { URL.revokeObjectURL(url); } catch { /* already revoked */ }
  }
  set.clear();
  pendingBlobUrls.delete(conversationId);
}
